/* __next_internal_client_entry_do_not_use__ HeaderMinimal auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { MINIMAL_HEADER_HEIGHT, MINIMAL_HEADER_HEIGHT_MOBILE } from "@faire/retailer-visitor-shared/components/Header/consts";
import { HeaderContainer } from "@faire/retailer-visitor-shared/components/Header/styled";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var HeaderMinimal = function(param) {
    var ref = param.ref, inactive = param.inactive;
    return /*#__PURE__*/ _jsx(HeaderContainer, {
        $isMinimal: true,
        ref: ref,
        children: /*#__PURE__*/ _jsx(LogoWrapper, {
            children: inactive ? /*#__PURE__*/ _jsx(FaireLogo, {}) : /*#__PURE__*/ _jsx(Link, {
                to: home(),
                children: /*#__PURE__*/ _jsx(FaireLogo, {})
            })
        })
    });
};
var LogoWrapper = styled.span.withConfig({
    componentId: "sc-23db97ae-0"
})([
    "display:flex;align-items:center;justify-content:center;height:",
    "px;",
    "{height:",
    "px;}"
], MINIMAL_HEADER_HEIGHT, responsiveMediaQueries.mobile, MINIMAL_HEADER_HEIGHT_MOBILE);
